import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { UpsellSection } from 'features/cart/components/cart-content/upsell-section';
import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';

import { Upsell } from 'pages/cart/upsell';

const UpsellCarouselWrapper = Box.withConfig({
  marginX: '$4',
});

export const ProductUpsell: React.FC = () => {
  const enableMinimalCartUi = useMinimalCartUi();
  if (enableMinimalCartUi) {
    return (
      <UpsellCarouselWrapper>
        <UpsellSection />
      </UpsellCarouselWrapper>
    );
  }
  return (
    <UpsellCarouselWrapper>
      <Upsell />
    </UpsellCarouselWrapper>
  );
};
